import { MoneyMapVisual } from './NewMoneyMapVisual';

export interface MoneyMapEmbeddedVisualProps {
    incomeTotalCents: number;
    billsTotalCents: number;
    spendTotalCents: number;
    goalsTotalCents: number;
}

export const MoneyMapEmbeddedVisual = (props: MoneyMapEmbeddedVisualProps) => {
    return <MoneyMapVisual {...props} variant="small" />;
};
